module.exports = __webpack_public_path__ + "images/RobotoCondensed-Light.svg";


//////////////////
// WEBPACK FOOTER
// ./web/fonts/RobotoCondensed-Light.svg
// module id = 830
// module chunks = 0